import React from "react";
import ErrorField from "./error";
import { OriginValues } from "core/enum";
import { observer } from "mobx-react";
import { SelectField } from "components/support";

const OriginOptions = Object.values(OriginValues).map(p => ({
  value: p.value,
  label: p.label
}));

const CofinsField = ({ errors, row, onChange }) => {
  const { taxes } = row || {};
  const foundErrors = errors.find(v => v.name === row.name);
  const hasErrors =
    foundErrors &&
    !!foundErrors.errors &&
    !!foundErrors.errors.taxes &&
    !!foundErrors.errors.taxes.origin;

  return (
    <div>
      {
        <SelectField
          fullWidth
          options={OriginOptions}
          value={taxes.origin}
          onChange={(_, value) => onChange(value)}
        />
      }
      {hasErrors && <ErrorField error={foundErrors.errors.taxes.origin} />}
    </div>
  );
};

export default observer(CofinsField);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/fields/origin.js